/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "tndaccountpingapi",
            "endpoint": "https://ryc0qw43m1.execute-api.us-east-2.amazonaws.com/production",
            "region": "us-east-2"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://t5jc3qfo03.execute-api.us-east-2.amazonaws.com/production",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://upxhaigx2neungq2fyvddrxbbe.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7nmklwecsjak5cgxpzawaqqkwq",
    "aws_cognito_identity_pool_id": "us-east-2:522815c4-3e94-4ef9-8fb1-738a252237d6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_hUx8Fu1iy",
    "aws_user_pools_web_client_id": "2jmnp6j26dc3qpfgaps61jbu9d",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
